import React, { useEffect, useState } from 'react';

import { getFanFavourites } from 'Redux/ducks/product';
import FanFavourites from 'Components/FanFavourites/FanFavourites';

const FanFavouritesContainer = () => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const results = await getFanFavourites({ hitsPerPage: 25, onsale: false });
      setHits(results);
      setHasLoaded(true);
    };

    if (!hasLoaded) fetchData();
  }, [hasLoaded]);
  return (
    <div className="container">
      <FanFavourites hits={hits} />
    </div>
  );
};

export default FanFavouritesContainer;
